import { render, staticRenderFns } from "./RefLineListAsList.vue?vue&type=template&id=bd2a1600"
import script from "./RefLineListAsList.vue?vue&type=script&lang=js"
export * from "./RefLineListAsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports